import { useContext } from 'react';
import { LoginModalContext } from '~/App/contexts/LoginModal';

export function useLoginModal() {
  return useContext(LoginModalContext);
}

export default useLoginModal;
